import type { Entry } from 'contentful';

import { TypeLocaleSkeleton } from '../models/cms';
import { LocaleData } from '../models';

export const transformLocale = (skeleton: Entry<TypeLocaleSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): LocaleData => ({
  label: skeleton.fields.label,
  id: skeleton.fields.id,
});
